module.exports = __webpack_public_path__ + "static/design-slacks.c80ff884.svg";